module.exports = __webpack_public_path__ + "img/tv.2e000e77.png";